import * as React from 'react';
import DefaultInput from './index';
const Input = (props) => {
    const { input, type = 'text', className, icon, meta: { touched, error }, ...restProps } = props;
    return (React.createElement(DefaultInput, { ...input, ...restProps, className: className, type: type, error: error && touched, icon: icon }));
};
export default Input;
